import React, { useState } from 'react';
import { Container } from '@mui/material';
import TopCategories from './TopCategories';
import SkillsList from './SkillsList';

const Skills = () => {
  const [selectedCategories, setSelectedCategory] = useState([]);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    console.log('Selected Category:', category); // Debugging
  };

  return (
    <Container maxWidth="md" sx={{ py: 1 }}>
      <TopCategories onCategorySelect={handleCategorySelect} />
      
      <SkillsList selectedCategories={selectedCategories}></SkillsList>
    </Container>
  );
};

export default Skills;